export default __webpack_public_path__ + "static/media/651.8b8001e4.png";